(() => {
  const configElement = document.getElementById('cp-forms-maison-config');
  if (!configElement || window.cpFormsMaisonInstalled) return;
  const config = JSON.parse(configElement.textContent);
  window.cpFormsMaisonInstalled = true;
  const hostId = `app-embed-container-${config.formId}`;
  const css = `
    :host { --forms-body-font: normal 400 16px 'CP Poppins', Arial, sans-serif !important; --forms-heading-font: normal 400 24px 'CP Poppins', Arial, sans-serif !important; }
    [data-cp-panel], [data-cp-panel] * { box-sizing: border-box !important; }
    [data-cp-panel] { display:grid !important; grid-template-columns:1fr 1fr !important; grid-template-rows:1fr !important; gap:0 !important; width:710px !important; min-width:0 !important; max-width:calc(100vw - 32px) !important; height:534px !important; min-height:0 !important; max-height:calc(100dvh - 32px) !important; margin:0 !important; padding:0 !important; border:0 !important; border-radius:5px !important; background:#fff !important; box-shadow:none !important; overflow:auto !important; color:#000; font-family:'CP Poppins',Arial,sans-serif; }
    [data-cp-panel] { grid-template-areas:'image content' !important; }
    [data-cp-photo] { display:block !important; grid-area:image !important; min-height:0 !important; min-width:0 !important; align-self:stretch !important; justify-self:stretch !important; background:var(--cp-forms-image) center/cover no-repeat !important; }
    [data-cp-content] { grid-column:2 !important; grid-row:1 !important; display:flex !important; flex-direction:column !important; justify-content:center !important; align-items:stretch !important; min-width:0 !important; margin:0 !important; padding:62px 20px 54px !important; text-align:center !important; }
    [data-cp-content] > section:not([data-testid]) { flex:none !important; margin:0 0 17px !important; width:100% !important; }
    [data-cp-brand] { display:flex; flex:none; align-items:center; justify-content:center; min-height:70px; margin:0 0 12px; }
    [data-cp-brand] img { display:block; width:200px; max-width:100%; height:auto; }
    [data-cp-content] h2 { margin:0 !important; padding:0 !important; color:#000 !important; font:400 24px/1.2 'CP Poppins',Arial,sans-serif !important; letter-spacing:0 !important; text-transform:none !important; }
    [data-cp-content] form { display:flex !important; flex-direction:column !important; gap:0 !important; margin:0 !important; padding:0 !important; }
    [data-cp-content] [class*="formFieldContainer"] { margin:0 0 10px !important; }
    [data-cp-content] input[data-testid="field-email"] { height:50px !important; min-height:50px !important; padding:0 16px !important; margin:0 !important; color:#000 !important; background:#fff !important; border:1px solid #000 !important; box-shadow:none !important; border-radius:4px !important; font:400 16px/1.4 'CP Poppins',Arial,sans-serif !important; }
    [data-cp-content] input::placeholder { color:#000 !important; opacity:1 !important; }
    [data-cp-content] label[for="email"] { position:absolute !important; width:1px !important; height:1px !important; padding:0 !important; margin:-1px !important; overflow:hidden !important; clip-path:inset(50%) !important; white-space:nowrap !important; }
    [data-testid="btn-form-submit"], [data-cp-continue] { display:flex !important; align-items:center !important; justify-content:center !important; width:100% !important; min-height:60px !important; padding:15px 10px !important; margin:0 !important; border:0 !important; border-radius:3px !important; background:#000 !important; color:#fff !important; font:700 18px/1.3 'CP Poppins',Arial,sans-serif !important; letter-spacing:1px !important; cursor:pointer; }
    [data-cp-decline] { align-self:center; min-height:44px; margin:16px 0 0; padding:10px 20px; background:transparent; color:#000; border:0; font:400 15px/1.4 'CP Poppins',Arial,sans-serif; cursor:pointer; }
    [data-cp-panel] [aria-label="Close modal"] { display:flex !important; align-items:center; justify-content:center; width:44px !important; height:44px !important; background:transparent !important; border-radius:0 !important; color:#37414a; }
    [data-cp-panel] [aria-label="Close modal"] svg { width:18px !important; height:18px !important; }
    [data-cp-panel] [class*="CloseButtonPosition"] { position:absolute !important; top:4px !important; right:4px !important; z-index:2; }
    [class*="overlayBackground"] { background:#000 !important; opacity:.55 !important; visibility:visible !important; animation:none !important; }
    [data-cp-content] { grid-area:content !important; }
    [data-cp-content] > [data-testid="banner-success"] { flex:none !important; margin:0 !important; }
    [data-cp-stage="success"] [data-cp-content] h2 { font-size:34px !important; font-weight:600 !important; margin-bottom:22px !important; }
    [data-cp-panel] [data-cp-message] { padding:0 !important; margin:0 !important; margin-block:0 !important; font:400 16px/1.55 'CP Poppins',Arial,sans-serif !important; color:#000 !important; }
    [data-cp-panel] [data-cp-continue] { margin-top:22px !important; flex-shrink:0 !important; }
    [data-cp-stage="success"] [data-cp-content] p { margin:0 !important; padding:0 !important; }
    [data-cp-content] :focus-visible { outline:2px solid #777; outline-offset:3px; }
    @media(max-width:600px) {
      [data-cp-panel] { width:360px !important; max-width:calc(100vw - 68px) !important; height:534px !important; max-height:calc(100dvh - 32px) !important; grid-template-columns:minmax(0,1fr) !important; grid-template-rows:minmax(0,1fr) !important; grid-template-areas:'content' !important; align-content:stretch !important; }
      [data-cp-photo] { display:none !important; }
      [data-cp-content] { grid-area:content !important; grid-column:1 !important; grid-row:1 !important; padding:62px 20px 64px !important; }
      [data-cp-brand] { min-height:64px; margin-bottom:18px; }
      [data-cp-brand] img { width:180px; }
      [data-cp-content] h2 { font-size:23px !important; }
      [data-cp-content] > section:not([data-testid]) { margin-bottom:18px !important; }
      [data-testid="btn-form-submit"], [data-cp-continue] { min-height:60px !important; font-size:16px !important; }
      [data-cp-decline] { margin-top:16px; }
      [data-cp-stage="success"] [data-cp-content] h2 { font-size:30px !important; }
    }
    @media(max-width:600px) and (max-height:560px) {
      [data-cp-content] { padding:40px 18px 24px !important; }
      [data-cp-brand] { min-height:40px; margin-bottom:10px; }
      [data-cp-content] h2 { font-size:21px !important; }
    }
  `;
  const enhance = host => {
    const root = host.shadowRoot;
    if (!root || host.dataset.cpMaison === 'true') return;
    host.dataset.cpMaison = 'true';
    host.style.setProperty('--cp-forms-image', `url("${config.image}")`);
    const style = document.createElement('style');
    style.dataset.cpMaisonStyle = '';
    style.textContent = css;
    root.append(style);
    const decorate = () => {
      const app = root.getElementById('app-embed');
      const panel = root.querySelector('[role="dialog"][aria-label]');
      if (!panel || !app) return;
      const stage = app.dataset.currentStep;
      const success = stage === 'success';
      const content = panel.querySelector('[class*="gridItemContent"]');
      if (!content || (!success && stage !== 'form')) return;
      panel.dataset.cpPanel = '';
      panel.dataset.cpStage = stage;
      content.dataset.cpContent = '';
      const photo = panel.querySelector(':scope > [class*="gridItem"]:not([class*="gridItemContent"])');
      if (photo) {
        photo.dataset.cpPhoto = '';
        if (photo.style.backgroundImage) host.style.setProperty('--cp-forms-image', photo.style.backgroundImage);
      }
      if (!content.querySelector('[data-cp-brand]')) {
        const brand = document.createElement('div');
        brand.dataset.cpBrand = '';
        const logo = document.createElement('img');
        logo.src = config.logo;
        logo.alt = 'Carmen Perla';
        logo.width = 489;
        logo.height = 59;
        brand.append(logo);
        const header = content.querySelector('section, h2');
        content.insertBefore(brand, header || content.firstChild);
      }
      const heading = content.querySelector('h2');
      const headingText = success ? '¡Bienvenida!' : '10 % de descuento en tu primera compra';
      if (heading && heading.textContent !== headingText) heading.textContent = headingText;
      panel.setAttribute('aria-label', headingText);
      const email = root.querySelector('[data-testid="field-email"]');
      if (email) {
        email.placeholder = 'Tu correo electrónico';
        email.autocomplete = 'email';
        const label = root.querySelector('label[for="email"]');
        if (label && label.textContent !== 'Tu correo electrónico') label.textContent = 'Tu correo electrónico';
      }
      if (success) {
        const message = content.querySelector('[data-testid="banner-success"] > div');
        if (message && !message.hasAttribute('data-cp-message')) {
          message.dataset.cpMessage = '';
          message.replaceChildren(document.createTextNode('Te hemos enviado tu código por email.'), document.createElement('br'), document.createTextNode('Revisa también tu carpeta de spam.'));
        }
      }
      const selector = success ? '[data-cp-continue]' : '[data-cp-decline]';
      if (!content.querySelector(selector)) {
        const button = document.createElement('button');
        button.type = 'button';
        if (success) button.dataset.cpContinue = '';
        else button.dataset.cpDecline = '';
        button.textContent = success ? 'SEGUIR COMPRANDO' : 'No, gracias';
        button.addEventListener('click', () => root.querySelector('[aria-label="Close modal"]')?.click());
        content.append(button);
      }
    };
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        observer.disconnect();
        decorate();
        observer.observe(root, {childList:true, subtree:true});
      });
    });
    decorate();
    observer.observe(root, {childList:true, subtree:true});
    window.addEventListener('pagehide', () => observer.disconnect(), {once:true});
  };
  const find = () => {
    const host = document.getElementById(hostId);
    if (!host?.shadowRoot) return false;
    enhance(host);
    return true;
  };
  if (!find()) {
    const observer = new MutationObserver(() => { if (find()) observer.disconnect(); });
    observer.observe(document.body, {childList:true, subtree:true});
    window.setTimeout(() => observer.disconnect(), 30000);
  }
})();

